import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  DOCUMENT,
  ChangeDetectionStrategy
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from './services/state.service';
import { Subscription } from 'rxjs';

import { LANGUAGES } from './data/languages';
import 'jquery';
import {CoolLocalStorage} from "@angular-cool/storage";
import {MatIconRegistry} from "@angular/material/icon";
import {DomSanitizer} from "@angular/platform-browser";
import { applyMobileTheme } from './data/mobile-themes';
declare var google: any;
interface Styles {
  colors: any;
  // Selects a mobile product-card preset; see data/mobile-themes.ts.
  mobileTheme?: string;
}

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    encapsulation: ViewEncapsulation.Emulated,
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  title = 'het-dienblad';
  styleSubscription: Subscription;
  styles: Styles = {
    colors: {}
  };

  constructor(@Inject(DOCUMENT) private document: Document,
              private translate: TranslateService,
              private _vault: CoolLocalStorage,
              private state: StateService,
              private zone: NgZone,
              private cd: ChangeDetectorRef,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer) {
    const availableLanguages = [];
    Object.keys(LANGUAGES).forEach(key => {
      availableLanguages.push(LANGUAGES[key]);
    });
    // Add available languages
    translate.addLangs(availableLanguages);
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe(event => {
      this.document.documentElement.lang = event.lang;
    });
    if (this.translate.currentLang) {
      this.document.documentElement.lang = this.translate.currentLang;
    }
    this.styleSubscription = this.state.formStyles$.subscribe(styles => {
      this.styles = styles;
      this.setColors();
    });
    this.detectMacSafari();
  }

  private detectMacSafari(): void {
    const ua = navigator.userAgent;
    const isMacSafari = /Safari/.test(ua)
      && !/Chrome|Chromium|CriOS/.test(ua)
      && !/iPhone|iPad|iPod/.test(ua);
    if (isMacSafari) {
      this.document.documentElement.classList.add('is-safari-mac');
      AppComponent.fixContainForSafari(this.document, 'app-root');
    }
  }

  /**
   * Safari Mac treats contain:layout as a containing block for position:fixed.
   * Walk up from the widget root and strip "layout" from any ancestor's contain value.
   */
  static fixContainForSafari(doc: Document, rootSelector: string): void {
    let el: Element | null = doc.querySelector(rootSelector)?.parentElement ?? null;
    while (el && el !== doc.body) {
      const contain = getComputedStyle(el).contain;
      if (contain && contain.includes('layout')) {
        (el as HTMLElement).style.contain = contain.replace(/\blayout\b/g, '').replace(/\s+/g, ' ').trim() || 'none';
      }
      el = el.parentElement;
    }
  }

  ngAfterViewInit() {
    this.zone.run(() => {
      this.cd.detectChanges();
    });
  }

  setColors(): void {
    // @ts-ignore
    const defaultConfig = require('../assets/default_css.json');

    if (this.styles.colors) {
      Object.keys(defaultConfig).forEach(key => {
        if (!this.styles.colors[key]) {
          if (defaultConfig[key].indexOf('$') > -1) {
            this.document.documentElement.style.setProperty(`--${key}`, `var(--${defaultConfig[key].replace('$', '')})`);
          } else {
            this.document.documentElement.style.setProperty(`--${key}`, defaultConfig[key]);
          }
        }
      });

      // Between the two passes, so an explicit styles.colors entry can still override a
      // single property of the chosen preset.
      applyMobileTheme(this.document, this.styles.mobileTheme);

      Object.keys(this.styles.colors).forEach(key => {
        if (this.styles.colors[key].indexOf('$') > -1) {
          this.document.documentElement.style.setProperty(`--${key}`, `var(--${this.styles.colors[key].replace('$', '')})`);
        } else {
          this.document.documentElement.style.setProperty(`--${key}`, this.styles.colors[key]);
        }
      });
    }
  }

  ngOnDestroy(): void {
    if (this.styleSubscription) {
      this.styleSubscription.unsubscribe();
    }
  }

}
